var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { isNil } from 'lodash-es';
import styles from '../../shared/sds-datepicker-item/_sds-date-picker-base.lit.scss';
import { sdsCustomElement } from '../../../utilities/custom-components';
let SdsYearPageNavigation = (() => {
    var _SdsYearPageNavigation_startYear_accessor_storage, _SdsYearPageNavigation_endYear_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-year-page-navigation')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _startYear_decorators;
    let _startYear_initializers = [];
    let _startYear_extraInitializers = [];
    let _endYear_decorators;
    let _endYear_initializers = [];
    let _endYear_extraInitializers = [];
    var SdsYearPageNavigation = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsYearPageNavigation_startYear_accessor_storage.set(this, __runInitializers(this, _startYear_initializers, void 0));
            _SdsYearPageNavigation_endYear_accessor_storage.set(this, (__runInitializers(this, _startYear_extraInitializers), __runInitializers(this, _endYear_initializers, void 0)));
            this.goToLastPage = (__runInitializers(this, _endYear_extraInitializers), () => this.changePage('LAST'));
            this.goToNextPage = () => this.changePage('NEXT');
        }
        get startYear() { return __classPrivateFieldGet(this, _SdsYearPageNavigation_startYear_accessor_storage, "f"); }
        set startYear(value) { __classPrivateFieldSet(this, _SdsYearPageNavigation_startYear_accessor_storage, value, "f"); }
        get endYear() { return __classPrivateFieldGet(this, _SdsYearPageNavigation_endYear_accessor_storage, "f"); }
        set endYear(value) { __classPrivateFieldSet(this, _SdsYearPageNavigation_endYear_accessor_storage, value, "f"); }
        render() {
            return html `
            <div class="sds-date-picker-toolbar">
                <sds-button
                    id="prev-year-page-button"
                    class="sds-date-picker-toolbar__icon"
                    type="secondary"
                    size="md"
                    icon="arrow_left_thin"
                    @click="${this.goToLastPage}"
                ></sds-button>
                ${this.renderToolbarTitle()}
                <sds-button
                    id="next-year-page-button"
                    class="sds-date-picker-toolbar__icon"
                    type="secondary"
                    size="md"
                    icon="arrow_right_thin"
                    @click="${this.goToNextPage}"
                ></sds-button>
            </div>
        `;
        }
        renderToolbarTitle() {
            if (!isNil(this.startYear) && !isNil(this.endYear)) {
                return html `
                <span class="sds-date-picker-toolbar__title">
                    ${this.startYear} - ${this.endYear}
                </span>
            `;
            }
        }
        changePage(direction) {
            this.dispatchEvent(new CustomEvent(SdsYearPageNavigation.PAGE_CHANGED_EVENT, {
                detail: {
                    step: direction === 'LAST' ? -1 : 1,
                },
            }));
        }
    };
    _SdsYearPageNavigation_startYear_accessor_storage = new WeakMap();
    _SdsYearPageNavigation_endYear_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsYearPageNavigation");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _startYear_decorators = [property()];
        _endYear_decorators = [property()];
        __esDecorate(_classThis, null, _startYear_decorators, { kind: "accessor", name: "startYear", static: false, private: false, access: { has: obj => "startYear" in obj, get: obj => obj.startYear, set: (obj, value) => { obj.startYear = value; } }, metadata: _metadata }, _startYear_initializers, _startYear_extraInitializers);
        __esDecorate(_classThis, null, _endYear_decorators, { kind: "accessor", name: "endYear", static: false, private: false, access: { has: obj => "endYear" in obj, get: obj => obj.endYear, set: (obj, value) => { obj.endYear = value; } }, metadata: _metadata }, _endYear_initializers, _endYear_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsYearPageNavigation = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.PAGE_CHANGED_EVENT = 'sds.year-page-navigation.page-changed';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsYearPageNavigation = _classThis;
})();
export { SdsYearPageNavigation };
